export default __webpack_public_path__ + "static/media/506.4a4c8318.png";